var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormElementRadioItem.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormElementRadioItem.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormInformationTv.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormInformationTv.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormElementRadioItem.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormInformationTv.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "SubmissionFormElementRadioItem")) {
var t_7 = t_4.SubmissionFormElementRadioItem;
} else {
cb(new Error("cannot import 'SubmissionFormElementRadioItem'")); return;
}
context.setVariable("SubmissionFormElementRadioItem", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"SubmissionFormInformationTv\">\n        <div class=\"SubmissionFormElement-form\">\n\n            <h3 class=\"SubmissionFormElement-header\">Project Information</h3>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName SubmissionFormElement-inputName--required\">PROJECT TITLE</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" value=\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title")) {
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title"), env.opts.autoescape);
;
}
t_9 += "\" name=\"title\" class=\"SubmissionFormElement-input\">\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine SubmissionFormElement-inputLine--radio\">\n                <div class=\"SubmissionFormElement-inputName SubmissionFormElement-inputName--required \">Filmed in US/Canada</div>\n                <div class=\"SubmissionFormElement-inputWrapper SubmissionFormElement-inputWrapper--radio\">\n                    ";
t_9 += runtime.suppressValue((lineno = 20, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormElementRadioItem"), "SubmissionFormElementRadioItem", context, ["SubmissionFormSetCheckbox-filmedInUs-1","filmedInUs",(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"filmedInUs") == true?1:((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"filmedInUs") == false?0:2))),1,"Yes"])), env.opts.autoescape);
t_9 += "\n                    ";
t_9 += runtime.suppressValue((lineno = 21, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormElementRadioItem"), "SubmissionFormElementRadioItem", context, ["SubmissionFormSetCheckbox-filmedInUs-0","filmedInUs",(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"filmedInUs") == true?1:((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"filmedInUs") == false?0:2))),0,"No"])), env.opts.autoescape);
t_9 += "\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine SubmissionFormElement-inputLine--radio SubmissionFormElement-inputLine--conditional ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"allNew")) {
t_9 += "SubmissionFormElement-inputLine--hidden";
;
}
t_9 += "\">\n                <div class=\"SubmissionFormElement-inputName SubmissionFormElement-inputName--required \">IATSE Agreement</div>\n                <div class=\"SubmissionFormElement-inputWrapper SubmissionFormElement-inputWrapper--radio\">\n                    ";
t_9 += runtime.suppressValue((lineno = 28, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormElementRadioItem"), "SubmissionFormElementRadioItem", context, ["SubmissionFormSetCheckbox-iatseAgreement-1","iatseAgreement",(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"iatseAgreement") == true?1:((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"iatseAgreement") == false?0:2))),1,"Yes"])), env.opts.autoescape);
t_9 += "\n                    ";
t_9 += runtime.suppressValue((lineno = 29, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormElementRadioItem"), "SubmissionFormElementRadioItem", context, ["SubmissionFormSetCheckbox-iatseAgreement-0","iatseAgreement",(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"iatseAgreement") == true?1:((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"iatseAgreement") == false?0:2))),0,"No"])), env.opts.autoescape);
t_9 += "\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName SubmissionFormElement-inputName--required\">DISTRIBUTION COMPANY/<br>STUDIO/NETWORK</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" value=\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"company")) {
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"company"), env.opts.autoescape);
;
}
t_9 += "\" name=\"company\" class=\"SubmissionFormElement-input\">\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName SubmissionFormElement-inputName--required SubmissionFormElement-inputName--top\">DESCRIBE PROJECT AND<br>YEAR(S) IT TAKES PLACE</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <textarea name=\"description\" class=\"SubmissionFormElement-textarea\">";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"description")) {
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"description"), env.opts.autoescape);
;
}
t_9 += "</textarea>\n                </div>\n            </div>\n\n            <div class=\"SubmissionFormElement-inputWrapper SubmissionFormInformationTv-pilotCheckbox\">\n                <input class=\"SubmissionFormElement-checkbox\" name=\"setsAllNew\" type=\"checkbox\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsAllNew")) {
t_9 += " checked";
;
}
t_9 += " id=\"SubmissionFormSetsAllNew\">\n                <label class=\"SubmissionFormElement-checkboxLabel\" for=\"SubmissionFormSetsAllNew\"><span></span><span>THIS IS A PILOT EPISODE</span></label>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("SubmissionFormInformationTv");
context.setVariable("SubmissionFormInformationTv", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormInformationTv.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormInformationTv.jinja
// module id = 57
// module chunks = 0